import React, { useState } from 'react'
import styles from './styles.module.scss'
import parentStyles from '../../../styles.module.scss'
import EmptyCard from '../../common/EmptyCard'
import { useTranslation } from 'react-i18next'
import CardSubTitle from '../../common/CardSubTitle'
import IconButton from 'srcReact/components/common2/IconButton'
import Icon from 'srcReact/components/icons/Icon'
import { formatDate, getDateFormat6 } from 'srcReact/helpers/datetimeHelper'
import { useDispatch, useSelector } from 'react-redux'
import { groupHomeActions } from 'srcReact/GroupHomePage'
import { dashboardActions } from 'srcReact/Dashboard/actions'
import PostFeedModal from 'srcReact/components/popinsContent/PostFeedModal'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'

function PendingSuggestions({ mixrSuggestions, isFullWidth }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const getColor = (key) => {
    const colors = ['orange', 'purple', 'blue']
    return colors[key % colors.length]
  }

  const {
    dashboardDetail: {
      mixrSuggestion: { error },
      data: { group_id, group_name, group_info: { cover_photo, newsfeed_id } = {} } = {}
    }
  } = useSelector((state) => state)

  const [isPostModalOpen, setIsPostModalOpen] = useState(false)

  const showPostModal = () => {
    setIsPostModalOpen(true)
  }
  const closePostModal = () => {
    setIsPostModalOpen(false)
  }

  const refuseAction = (mixrId) => {
    dispatch(dashboardActions.rejectSuggestMixR(mixrId))
  }

  const acceptAction = (mixrId) => {
    dispatch(dashboardActions.acceptSuggestMixR(mixrId))
  }

  return mixrSuggestions?.length > 0 ? (
    <div className={`${parentStyles.card} ${styles.pendingSuggestions} ${isFullWidth && styles.fullWidth}`}>
      <CardSubTitle title={t('dashboard.mixrSuggestionCount', { count: mixrSuggestions?.length || 0 })} />
      {error && <ErrorMessage text={error} className={styles.error} />}

      <div className={styles.list}>
        {mixrSuggestions.map((mixr, index) => {
          const mixrInfo = mixr.mixr_info
          return (
            <div key={mixr.id} className={`${styles.listItem} ${styles[getColor(index)]}`}>
              <div className={styles.left}>
                <p className={styles.date}>{formatDate(mixrInfo.start_at, getDateFormat6())}</p>
                <p className={styles.title}>{mixrInfo.name}</p>
                <a href={`${mixrInfo.url}`} className={styles.more}>
                  {t('global.moreInfo')}
                  <Icon name='arrow-left24' size='x-small' isFlipped />
                </a>
              </div>
              <div className={styles.right}>
                <IconButton
                  className={styles.refuseButton}
                  iconName='close24'
                  iconSize='x-small'
                  onClick={() => refuseAction(mixrInfo.id)}
                />
                <IconButton
                  className={styles.acceptButton}
                  iconName='check24'
                  iconSize='x-small'
                  onClick={() => acceptAction(mixrInfo.id)}
                />
              </div>
            </div>
          )
        })}
      </div>

      {isPostModalOpen && (
        <PostFeedModal
          newsfeedId={newsfeed_id}
          isModalOpen={isPostModalOpen}
          closeModal={closePostModal}
          objectId={group_id}
          objectName={group_name}
          objectPicture={cover_photo}
          objectType='group'
          showSuccessBanner={true}
          showGroupInfoBanner={true}
        />
      )}
    </div>
  ) : null
}

export default PendingSuggestions
